import React from 'react';
import { Box, Typography } from '@mui/material';
import IPhoneFrame, {
  StatusBar, NavBar, HomeBar,
  IOS_FONT, IOS_BLUE, IOS_GRAY_BG, IOS_GRAY_FIELD, IOS_GRAY_TEXT, IOS_SEPARATOR,
} from './IPhoneFrame';
import { STUDENT } from '../sharedMockData';

/**
 * L1 auth — AchieveDXP dashboard login rendered inside the parent WKWebView.
 * The webview presents the existing Nucleos login page; the SwiftUI chrome
 * is just the status bar and a subtle "AchieveDXP iOS v1.0" nav title.
 */
const IosLoginMockup = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', p: 3, bgcolor: '#eceff1', minHeight: '100%' }}>
    <IPhoneFrame
      title="1. Login (AchieveDXP in WKWebView)"
      caption="Layer 1 auth — user signs into the AchieveDXP web dashboard inside the parent WKWebView. SwiftUI chrome is a thin nav title only."
    >
      <StatusBar />
      <NavBar
        title="AchieveDXP"
        subtitle="🍎 AchieveDXP iOS v1.0"
      />
      {/* WKWebView rendering the Nucleos web login */}
      <Box sx={{
        position: 'absolute',
        top: 44 + 44,
        left: 0, right: 0, bottom: 83,
        bgcolor: '#fff',
        overflow: 'auto',
      }}>
        {/* webview URL bar stand-in */}
        <Box sx={{
          display: 'flex', alignItems: 'center', gap: 0.5,
          px: 1.2, py: 0.8,
          bgcolor: '#F6F6F6',
          borderBottom: `0.5px solid ${IOS_SEPARATOR}`,
          fontFamily: IOS_FONT,
        }}>
          <Box sx={{ fontSize: '11px', color: IOS_GRAY_TEXT }}>🔒</Box>
          <Typography sx={{ fontFamily: IOS_FONT, fontSize: '12px', color: '#3C3C43', flex: 1 }}>
            achievedxp.nucleos.com
          </Typography>
          <Box sx={{ fontSize: '14px', color: IOS_BLUE }}>⟳</Box>
        </Box>

        <Box sx={{ px: 3, pt: 5, pb: 3, textAlign: 'center' }}>
          {/* Nucleos logo-ish */}
          <Box sx={{
            width: 72, height: 72,
            bgcolor: '#1a1a2e',
            borderRadius: 3,
            mx: 'auto', mb: 2,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 700, fontFamily: IOS_FONT, fontSize: '22px',
          }}>N</Box>
          <Typography sx={{
            fontFamily: IOS_FONT, fontSize: '22px', fontWeight: 700, color: '#1a1a2e', mb: 0.5,
          }}>Welcome to AchieveDXP</Typography>
          <Typography sx={{
            fontFamily: IOS_FONT, fontSize: '14px', color: IOS_GRAY_TEXT, mb: 4,
          }}>Sign in to continue</Typography>

          {/* Email */}
          <Box sx={{ mb: 1.5, textAlign: 'left' }}>
            <Typography sx={{
              fontFamily: IOS_FONT, fontSize: '12px', color: IOS_GRAY_TEXT,
              textTransform: 'uppercase', letterSpacing: '0.5px', mb: 0.7, ml: 0.5,
            }}>Email</Typography>
            <Box sx={{
              bgcolor: IOS_GRAY_FIELD,
              borderRadius: 2.5,
              px: 1.5, py: 1.3,
              fontFamily: IOS_FONT, fontSize: '16px', color: '#000',
            }}>{STUDENT.email}</Box>
          </Box>

          {/* Password */}
          <Box sx={{ mb: 3, textAlign: 'left' }}>
            <Typography sx={{
              fontFamily: IOS_FONT, fontSize: '12px', color: IOS_GRAY_TEXT,
              textTransform: 'uppercase', letterSpacing: '0.5px', mb: 0.7, ml: 0.5,
            }}>Password</Typography>
            <Box sx={{
              bgcolor: IOS_GRAY_FIELD,
              borderRadius: 2.5,
              px: 1.5, py: 1.3,
              fontFamily: IOS_FONT, fontSize: '16px', color: '#000',
              letterSpacing: '3px',
            }}>••••••••••</Box>
          </Box>

          {/* Sign in button */}
          <Box sx={{
            bgcolor: IOS_BLUE,
            borderRadius: 2.5,
            py: 1.4,
            fontFamily: IOS_FONT, fontSize: '17px', fontWeight: 600,
            color: '#fff', mb: 2, cursor: 'pointer',
          }}>Sign In</Box>

          <Typography sx={{
            fontFamily: IOS_FONT, fontSize: '14px', color: IOS_BLUE, mb: 3,
          }}>Forgot password?</Typography>

          {/* Face ID suggestion */}
          <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: 1, color: IOS_GRAY_TEXT, mt: 4,
          }}>
            <Box sx={{ fontSize: '22px' }}>⦿</Box>
            <Typography sx={{ fontFamily: IOS_FONT, fontSize: '13px' }}>
              Use Face ID to sign in next time
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* No tab bar on login screen — full WebView experience */}
      <HomeBar />
    </IPhoneFrame>
  </Box>
);

export default IosLoginMockup;
